import { listen } from '@tauri-apps/api/event'
import { isTauriRuntime } from '~/lib/platform/runtime'

// macOS fullscreen: the native Esc monitor in src-tauri/src/lib.rs swallows Esc so it doesn't
// take the window out of fullscreen — which also keeps it from ever reaching the webview. Replay
// it as a DOM keydown/keyup on the focused element so dialogs, menus, search and hotkeys
// ('common.cancel') close on Esc in fullscreen the same way they do in a normal window.
export default defineNuxtPlugin(() => {
  if (!isTauriRuntime()) return
  void listen('app-escape-swallowed', () => {
    const target = document.activeElement ?? document.body
    const init: KeyboardEventInit = { key: 'Escape', code: 'Escape', keyCode: 27, which: 27, bubbles: true, cancelable: true, composed: true }
    target.dispatchEvent(new KeyboardEvent('keydown', init))
    target.dispatchEvent(new KeyboardEvent('keyup', init))
  })
})
